module.exports = __webpack_public_path__ + "static/media/link-tool-white.79d7a10a.svg";